import { render, staticRenderFns } from "./CourseCalendarView.vue?vue&type=template&id=b49a9dea&scoped=true"
import script from "./CourseCalendarView.vue?vue&type=script&lang=ts"
export * from "./CourseCalendarView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49a9dea",
  null
  
)

export default component.exports